const addOntypes = {
  COVER_THE_FEES: "CoverTheFees",
  PERCENTAGE: "Percentage",
  AMOUNT: "Amount",
};

const ctaTypes = {
  GIVE_TO_FUND: "GiveToFund",
  MESSAGE: "Message",
  PLEDGE: "Pledge",
  RECURRING_GIFT: "RecurringGift",
  /** redundant to pledge. Use for converting to pledge only. */
  CAMPAIGN_STATUS: "CampaignStatus",
};

const ctaTypesWithIds = [
  [ctaTypes.GIVE_TO_FUND, 1],
  [ctaTypes.MESSAGE, 2],
  [ctaTypes.PLEDGE, 3],
  [ctaTypes.RECURRING_GIFT, 4],
];

const ctaTypeToId = Object.fromEntries(ctaTypesWithIds);
const ctaIdToType = Object.fromEntries(
  ctaTypesWithIds.map((elem) => [elem[1], elem[0]])
);

const ctaData = [
  {
    title: "Give to Fund",
    icon: "hand-holding-usd fas",
    description: "Prompt contributions to a designated fund.",
    id: ctaTypeToId[ctaTypes.GIVE_TO_FUND],
    type: ctaTypes.GIVE_TO_FUND,
  },
  {
    title: "Message",
    icon: "megaphone fas",
    description: "Craft a personalized message with a link.",
    id: ctaTypeToId[ctaTypes.MESSAGE],
    type: ctaTypes.MESSAGE,
  },
  {
    title: "Pledge",
    icon: "fa-thermometer-half fas",
    description: "Encourage individuals to pledge towards a campaign.",
    id: ctaTypeToId[ctaTypes.PLEDGE],
    type: ctaTypes.PLEDGE,
  },
  {
    title: "Recurring Gift",
    icon: "sync-alt fas",
    description: "Establish automatic, recurring donations to a fund.",
    id: ctaTypeToId[ctaTypes.RECURRING_GIFT],
    type: ctaTypes.RECURRING_GIFT,
  },
];

const recurringGiftOptions = [
  { label: "Weekly", id: 1 },
  { label: "Monthly", id: 2 },
  { label: "Quarterly", id: 3 },
  { label: "Annually", id: 4 },
];

const pledgeIntervalOptions = [
  { label: "One Time", id: 1 },
  { label: "Weekly", id: 2 },
  { label: "Monthly", id: 3 },
  { label: "Quarterly", id: 4 },
  { label: "Annually", id: 5 },
];

const ADD_ON_GIFT_LIMIT = 3;
const CTA_SLOT_LIMIT = 6;

/** Official spelling for "Add-on Gifts". */
const ADD_ON_GIFTS = "Add-on Gifts";
/** Official spelling for "Cover transaction fees". */
const COVER_TRANSACTION_FEES = "Cover transaction fees";
/** Official spelling for "Call To Action" */
const CALL_TO_ACTION = "Call to Action";

// the limit for the description field. Here since is is used in the Happe Tools
const ADD_ON_TITLE_CHAR_LIMIT = 50;
const ADD_ON_DESCRIPTION_CHAR_LIMIT = 255;
const ADD_ON_DESCRIPTION_ENABLED = false;
const GIVING_SETTINGS_TAB_LOCAL_STORAGE_KEY =
  "GIVING_SETTINGS_TAB_LOCAL_STORAGE_KEY";

const CTA_TITLE_CHAR_LIMIT = 50;
const CTA_DESCRIPTION_CHAR_LIMIT = 255;

const alertTypes = {
  WEPAY_CC_ALERT: "WePay CC Alert",
  WEPAY_ACH_ALERT: "WePay ACH Alert",
  PLEDGE_PAYMENT_ALERT: "Pledge Payment Alert",
  PLEDGE_BEHIND_ALERT: "Pledge Behind Alert",
};

const alertTypesWithId = [
  [alertTypes.WEPAY_ACH_ALERT, 1],
  [alertTypes.PLEDGE_PAYMENT_ALERT, 2],
  [alertTypes.PLEDGE_BEHIND_ALERT, 3],
  [alertTypes.WEPAY_CC_ALERT, 4],
];

const alertTypeToId = Object.fromEntries(alertTypesWithId);
const alertIdToType = Object.fromEntries(
  Object.entries(alertTypesWithId).map((elem) => [elem[1], elem[0]])
);

const alertData = [
  {
    title: "WePay ACH Alert",
    description: "Alert people that they can give via ACH.",
    id: alertTypeToId[alertTypes.WEPAY_ACH_ALERT],
    type: alertTypes.WEPAY_ACH_ALERT,
  },
  {
    title: "Pledge Payment Alert",
    description: "Alert people that they can pay their pledge.",
    id: alertTypeToId[alertTypes.PLEDGE_PAYMENT_ALERT],
    type: alertTypes.PLEDGE_PAYMENT_ALERT,
  },
  {
    title: "Pledge Behind Alert",
    description: "Alert people that they are behind on their pledge.",
    id: alertTypeToId[alertTypes.PLEDGE_BEHIND_ALERT],
    type: alertTypes.PLEDGE_BEHIND_ALERT,
  },
  {
    title: "WePay CC Alert",
    description: "Alert people that they can't give via CC.",
    id: alertTypeToId[alertTypes.WEPAY_CC_ALERT],
    type: alertTypes.WEPAY_CC_ALERT,
  },
];

export {
  addOntypes,
  ctaTypes,
  ctaTypeToId,
  ctaIdToType,
  ctaData,
  alertTypes,
  alertTypeToId,
  alertIdToType,
  alertData,
  recurringGiftOptions,
  pledgeIntervalOptions,
  ADD_ON_GIFT_LIMIT,
  CTA_SLOT_LIMIT,
  ADD_ON_GIFTS,
  COVER_TRANSACTION_FEES,
  CALL_TO_ACTION,
  ADD_ON_DESCRIPTION_CHAR_LIMIT,
  ADD_ON_TITLE_CHAR_LIMIT,
  ADD_ON_DESCRIPTION_ENABLED,
  GIVING_SETTINGS_TAB_LOCAL_STORAGE_KEY,
  CTA_TITLE_CHAR_LIMIT,
  CTA_DESCRIPTION_CHAR_LIMIT,
};
